module.exports = __webpack_public_path__ + "static/media/bg-banner-home.a93c9ebf.png";